/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from "react-intl";
import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";
import { SidebarMenuItem } from "./SidebarMenuItem";
import {
  ehAdministradorDoClube,
  getAuth,
} from "../../../../../app/modules/auth";
import { useEffect, useState } from "react";
import axios from "axios";
import { useStyleContext } from "../../../../helpers/StyleContext";
import clsx from "clsx";

async function getMenuItems() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiToken = getAuth();
  const token = apiToken?.api_token ?? "";

  const sidebarHeaders = {
    Authorization: `Bearer ${token}`,
  };

  return await axios
    .get(`${apiUrl}/sidebar-menu`, { headers: sidebarHeaders })
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return {
        company: {
          locations: false,
          braceletColors: false,
          contracts: false,
        },
        contracts: {
          templates: false,
          discounts: false,
        },
        plans: {
          discountCoupons: false,
          plans: false,
        },
        users: {
          users: false,
          permissions: false,
          roles: false,
          employees: false,
        },
        technicalCommittee: {
          members: false,
          categories: false,
          plans: false,
        },
        sponsors: {
          list: false,
          roles: false,
          plans: false,
        },
        athletes: {
          list: false,
          roles: false,
        },
        logistics: {
          suppliers: false,
          stock: false,
        },
        operations: {
          menu: false,
          cashier: false,
        },
        financial: {
          accountsPayableReceivable: false,
        },
        audit: {
          history: false,
        },
      };
    });
}

const SidebarMenuMain = (textColor: any, iconColor: any) => {
  const intl = useIntl();

  const [menuItems, setMenuItems] = useState<any>({
    company: {
      locations: false,
      braceletColors: false,
      contracts: false,
    },
    contracts: {
      templates: false,
      discounts: false,
    },
    plans: {
      discountCoupons: false,
      plans: false,
    },
    users: {
      users: false,
      permissions: false,
      roles: false,
      employees: false,
    },
    technicalCommittee: {
      members: false,
      categories: false,
      plans: false,
    },
    sponsors: {
      list: false,
      roles: false,
      plans: false,
    },
    athletes: {
      list: false,
      roles: false,
    },
    logistics: {
      suppliers: false,
      stock: false,
    },
    operations: {
      menu: false,
      cashier: false,
    },
    financial: {
      accountsPayableReceivable: false,
    },
    audit: {
      history: false,
    },
  });

  const { styleState } = useStyleContext();

  useEffect(() => {
    async function fetchMenuItems() {
      const items = await getMenuItems();
      setMenuItems(items);
    }

    fetchMenuItems();
  }, []);

  const showUsersMenu = Object.values(menuItems?.users || {}).some(
    (value) => value === true
  );

  const showPlansMenu = Object.values(menuItems?.plans || {}).some(
    (value) => value === true
  );

  const showCompanyMenu = Object.values(menuItems?.company || {}).some(
    (value) => value === true
  );

  return (
    <div
      className="menu menu-column menu-rounded menu-sub-indention px-3 hover-scroll-y d-flex flex-column h-100"
      id="kt_app_sidebar_menu"
      data-kt-menu="true"
      data-kt-scroll="true"
      data-kt-scroll-activate="true"
      data-kt-scroll-height="auto"
      data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
      data-kt-scroll-wrappers="#kt_app_sidebar_menu"
      data-kt-scroll-offset="5px"
    >
      {/* 1. SEÇÃO SUPERIOR (ITENS E ACORDEÕES DO TOPO) */}
      <div className="flex-grow-0">
        <div className="menu-top-section">
          <SidebarMenuItem
            textColor={textColor}
            iconColor={iconColor}
            to="/dashboard"
            icon="/media/icons/duotune/art/art002.svg"
            title={intl.formatMessage({ id: "MENU.DASHBOARD" })}
            fontIcon="bi-app-indicator"
          />

          {menuItems?.users?.users && (
            <SidebarMenuItem
              to="/users"
              icon="media/icons/duotune/communication/com006.svg"
              title={intl.formatMessage({
                id: "MENU.MODULE.MANAGEUSERS",
              })}
              fontIcon="bi-app-indicator"
            />
          )}

          {/* <SidebarMenuItem
            to="/sales"
            icon="/media/icons/duotune/general/gen064.svg"
            title={intl.formatMessage({ id: "MENU.SELLPLANS" })}
            fontIcon="bi-app-indicator"
          /> */}

          <SidebarMenuItem
            to="/notifications"
            icon="/media/icons/duotune/general/gen048.svg"
            title={intl.formatMessage({ id: "MENU.NOTIFICATIONS" })}
            fontIcon="bi-app-indicator"
          />

          <SidebarMenuItem
            to="/my-plan"
            icon="/media/icons/duotune/general/gen019.svg"
            title={intl.formatMessage({
              id: "MENU.MYPLAN",
              defaultMessage: "Meu plano",
            })}
            fontIcon="bi-app-indicator"
          />

          {/* AAC-22: só o administrador do clube (o gateway responde 403 aos demais). */}
          {ehAdministradorDoClube() && (
            <SidebarMenuItemWithSub
              to="/configuracoes"
              title="Configurações"
              icon="/media/icons/duotune/coding/cod001.svg"
              fontIcon="bi-gear"
            >
              <SidebarMenuItem
                to="/configuracoes/recebimento-sicredi"
                title="Recebimento Sicredi"
                hasBullet
              />
            </SidebarMenuItemWithSub>
          )}

          {menuItems?.technicalCommittee?.members && (
            <SidebarMenuItem
              to="/technical-committee"
              icon="media/icons/duotune/communication/com007.svg"
              title={intl.formatMessage({ id: "MENU.TECHNICALCOMMITTEE" })}
              fontIcon="bi-app-indicator"
            />
          )}

          {menuItems?.sponsors?.list && (
            <SidebarMenuItem
              to="/sponsor"
              icon="media/icons/duotune/communication/com003.svg"
              title={intl.formatMessage({ id: "MENU.SPONSOR" })}
              fontIcon="bi-app-indicator"
            />
          )}

          {menuItems?.logistics?.suppliers && (
            <SidebarMenuItem
              to="/fornecedores"
              icon="media/icons/duotune/general/gen049.svg"
              title={intl.formatMessage({ id: "MENU.FORNECEDORES" })}
              fontIcon="bi-app-indicator"
            />
          )}

          {menuItems?.logistics?.stock && (
            <SidebarMenuItemWithSub
              to="/estoque"
              title={intl.formatMessage({ id: "MENU.ESTOQUE" })}
              icon="media/icons/duotune/general/gen025.svg"
              fontIcon="bi-app-indicator"
            >
              <SidebarMenuItem
                to="/estoque"
                title="Listagem"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/estoque/setores"
                title="Setores"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/estoque/entrada-manual"
                title="Entrada Manual"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/estoque/entrada-xml"
                title="Entrada XML"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/estoque/saida"
                title="Saída"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/estoque/relatorio"
                title="Relatório"
                hasBullet={true}
              />
            </SidebarMenuItemWithSub>
          )}

          {menuItems?.operations?.menu && (
            <SidebarMenuItemWithSub
              to="/cardapio"
              title={intl.formatMessage({ id: "MENU.CARDAPIO" })}
              icon="media/icons/duotune/general/gen014.svg"
              fontIcon="bi-app-indicator"
            >
              <SidebarMenuItem
                to="/cardapio"
                title="Listagem"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/cardapio/pedido"
                title="Pedido / Nota"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/cardapio/cliente"
                title="Cardápio do Cliente"
                hasBullet={true}
              />
            </SidebarMenuItemWithSub>
          )}

          {menuItems?.operations?.cashier && (
            <SidebarMenuItemWithSub
              to="/caixa-financeiro"
              title="Caixa"
              icon="media/icons/duotune/finance/fin002.svg"
              fontIcon="bi-cash-coin"
            >
              <SidebarMenuItem
                to="/caixa-financeiro"
                title="Painel"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/abertura"
                title="Abertura"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/frente"
                title="Frente de Caixa"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/transacoes"
                title="Transações"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/sangria"
                title="Sangria / Suprimento"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/pagamentos"
                title="Pagamentos"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/pulseiras"
                title="Pulseiras"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/operadores"
                title="Operadores"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/comissoes"
                title="Comissões"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/fechamento"
                title="Fechamento"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/relatorios"
                title="Relatórios"
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/caixa-financeiro/auditoria"
                title="Auditoria"
                hasBullet={true}
              />
            </SidebarMenuItemWithSub>
          )}

          {menuItems?.financial?.accountsPayableReceivable && (
            <SidebarMenuItemWithSub
              to="/financeiro"
              title={intl.formatMessage({ id: "MENU.CONTAS_PAGAR_RECEBER" })}
              icon="media/icons/duotune/finance/fin010.svg"
              fontIcon="bi-cash-coin"
            >
              <SidebarMenuItem
                to="/financeiro/plano-contas"
                title={intl.formatMessage({ id: "MENU.CONTAS.PLANO_CONTAS" })}
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/financeiro/centros-custo"
                title={intl.formatMessage({ id: "MENU.CONTAS.CENTROS_CUSTO" })}
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/financeiro/contas-pagar"
                title={intl.formatMessage({ id: "MENU.CONTAS.CONTAS_PAGAR" })}
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/financeiro/contas-receber"
                title={intl.formatMessage({ id: "MENU.CONTAS.CONTAS_RECEBER" })}
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/financeiro/fluxo-caixa"
                title={intl.formatMessage({ id: "MENU.CONTAS.FLUXO_CAIXA" })}
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/financeiro/conciliacao"
                title={intl.formatMessage({ id: "MENU.CONTAS.CONCILIACAO" })}
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/financeiro/dre"
                title={intl.formatMessage({ id: "MENU.CONTAS.DRE" })}
                hasBullet={true}
              />
              <SidebarMenuItem
                to="/financeiro/relatorios"
                title={intl.formatMessage({ id: "MENU.CONTAS.RELATORIOS" })}
                hasBullet={true}
              />
            </SidebarMenuItemWithSub>
          )}

          {menuItems?.audit?.history && (
            <SidebarMenuItemWithSub
              to="/historic"
              title={intl.formatMessage({ id: "MENU.HISTORIC" })}
              icon="/media/icons/duotune/coding/cod002.svg"
              fontIcon="bi-person"
            >
              {menuItems?.users?.permissions && (
                <SidebarMenuItem
                  to="/generalaccess"
                  title={intl.formatMessage({
                    id: "MENU.HISTORIC.GENERALACCESS",
                  })}
                  hasBullet={true}
                />
              )}
              {menuItems?.users?.roles && (
                <SidebarMenuItem
                  to="/invoicingpayments"
                  title={intl.formatMessage({
                    id: "MENU.HISTORIC.INVOICINGPAYMENTS",
                  })}
                  hasBullet={true}
                />
              )}
            </SidebarMenuItemWithSub>
          )}
        </div>
      </div>

      {/* 2. SEÇÃO INFERIOR (MÓDULOS) */}
      <div className="mt-auto pb-10">
        <div className="menu-item">
          <div className="menu-content pt-8 pb-2">
            <span
              className={clsx("menu-section text-uppercase fs-8 ls-1", {
                "text-muted": !styleState.sidebar_text_color,
              })}
              style={{ color: styleState?.sidebar_text_color }}
            >
              {intl.formatMessage({ id: "MENU.MODULES" })}
            </span>
          </div>
        </div>

        {showCompanyMenu && (
          <SidebarMenuItemWithSub
            to="/dashboard/companies"
            title={intl.formatMessage({
              id: "MENU.MODULE.MANAGECOMPANIES",
            })}
            fontIcon="bi-archive"
            icon="/media/icons/duotune/general/gen022.svg"
          >
            {menuItems?.company?.locations && (
              <SidebarMenuItem
                to="/locations"
                title={intl.formatMessage({
                  id: "MODULE.MANAGECOMPANIE.LOCATIONS",
                })}
                hasBullet={true}
              />
            )}
            {menuItems?.company?.braceletColors && (
              <SidebarMenuItem
                to="/bracelet-colors"
                title={intl.formatMessage({
                  id: "MODULE.MANAGECOMPANIE.BRACELETCOLORS",
                })}
                hasBullet={true}
              />
            )}
            {menuItems?.company?.contracts && (
              <SidebarMenuItem
                to="/templates"
                title={intl.formatMessage({
                  id: "MODULE.MANAGECOMPANIE.CONTRACTS",
                })}
                hasBullet={true}
              />
            )}
            {menuItems?.users?.roles && (
              <SidebarMenuItem
                to="/roles"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGEUSERS.ROLES",
                })}
                hasBullet={true}
              />
            )}
          </SidebarMenuItemWithSub>
        )}

        {showUsersMenu && (
          <SidebarMenuItemWithSub
            to="/change"
            title={intl.formatMessage({
              id: "MENU.MODULE.MANAGEEMPLOYEES",
            })}
            icon="/media/icons/duotune/communication/com006.svg"
            fontIcon="bi-person"
          >
            {menuItems?.users?.employees && (
              <SidebarMenuItem
                to="/employees"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGEEMPLOYEES.EMPLOYEE",
                })}
                hasBullet={true}
              />
            )}
            {menuItems?.users?.permissions && (
              <SidebarMenuItem
                to="/permissions"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGEUSERS.PERMISSIONS",
                })}
                hasBullet={true}
              />
            )}
          </SidebarMenuItemWithSub>
        )}

        {showPlansMenu && (
          <SidebarMenuItemWithSub
            to="/dashboard/planos"
            title={intl.formatMessage({ id: "MENU.MODULE.USERPLANS" })}
            fontIcon="bi-archive"
            icon="/media/icons/duotune/general/gen049.svg"
          >
            {menuItems?.plans?.plans && (
              <SidebarMenuItem
                to="/plans"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGEPLANS.PLANS",
                })}
                hasBullet={true}
              />
            )}
            {/* {menuItems?.plans?.discountCoupons && (
              <SidebarMenuItem
                to="/discount-coupons"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGEPLANS.DISCOUNTCOUPONS",
                })}
                hasBullet={true}
              />
            )} */}
          </SidebarMenuItemWithSub>
        )}

        {menuItems?.technicalCommittee?.members && (
          <SidebarMenuItemWithSub
            to="/committee-management"
            title={intl.formatMessage({
              id: "MENU.MODULE.MANAGECOMMITTEE",
            })}
            fontIcon="bi-archive"
            icon="/media/icons/duotune/maps/map004.svg"
          >
            {menuItems?.technicalCommittee?.categories && (
              <SidebarMenuItem
                to="/committee-management/categories"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGECOMMITTEE.CATEGORIES",
                })}
                hasBullet={true}
              />
            )}
            {menuItems?.technicalCommittee?.plans && (
              <SidebarMenuItem
                to="/committee-management/plans"
                title={intl.formatMessage({
                  id: "MENU.MODULE.MANAGECOMMITTEE.PLANS",
                })}
                hasBullet={true}
              />
            )}
          </SidebarMenuItemWithSub>
        )}

        {menuItems?.sponsors?.list && (
          <SidebarMenuItemWithSub
            to="/sponsor-management"
            title={intl.formatMessage({ id: "MENU.MODULE.SPONSORS" })}
            fontIcon="bi-archive"
            icon="/media/icons/duotune/technology/teh009.svg"
          >
            {menuItems?.sponsors?.plans && (
              <SidebarMenuItem
                to="/sponsor-management/plans"
                title={intl.formatMessage({
                  id: "MENU.MODULE.SPONSORS.PLANS",
                })}
                hasBullet={true}
              />
            )}
          </SidebarMenuItemWithSub>
        )}

        {menuItems?.company?.contracts && (
          <SidebarMenuItemWithSub
            to="/sponsor-management"
            title={intl.formatMessage({ id: "MENU.MODULE.PAYMENTS" })}
            fontIcon="bi-archive"
            icon="/media/icons/duotune/general/gen022.svg"
          >
            <SidebarMenuItem
              to="/collection"
              title={intl.formatMessage({
                id: "MENU.MODULE.PAYMENTS.COLLECTIONS",
              })}
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>
        )}
      </div>

      {/* ✅ SEU PRINT_R NA TELA */}
      {/* <div
        style={{
          background: "#1e1e2d",
          color: "#00ff66",
          padding: "15px",
          margin: "10px",
          borderRadius: "8px",
          fontSize: "12px",
          fontFamily: "monospace",
          minHeight: "250px",
          height: "400px",
          overflow: "auto",
          border: "1px solid #00ff66",
        }}
      >
        <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
          DEBUG - PERMISSÕES CARREGADAS (menuItems):
        </div>
        <pre style={{ margin: 0, color: "#00ff66" }}>
          {JSON.stringify(menuItems, null, 2)}
        </pre>
      </div> */}
    </div>
  );
};

export { SidebarMenuMain };